'use client'

import styled from "styled-components";
import titleLogo from "asset/photomag_web/img/icon/filled/developer-board.svg"
import deviceLogo from "asset/mobile_web/img/device.png"
import cameraImg from "asset/mobile_web/img/icon/filled/icon-btn/camera-alt.svg"
import coinImg from "asset/mobile_web/img/icon/filled/icon-btn/style.svg"
import prgmImg from "asset/mobile_web/img/icon/filled/icon-btn/blur-on.svg"
import offImg from "asset/mobile_web/img/icon/filled/icon-btn/free-icon-on-off-button-1228.png"
import connectFailImg from "asset/photomag_web/img/연결실패.png";
import receiveScreen from "asset/img/receive_screen.png";

import printV from "asset/img/icon/filled/icon-btn/print_v.png"
import printH from "asset/img/icon/filled/icon-btn/print_h.png"

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faSquare } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useEffect, useState } from "react";
import { callApi } from "util/HttpService";
import { alert, modalConfirm } from "components/web/cmmn/CmmnConfirm";
import moment from "moment";
import ButtonUtil from "components/mobile/UI/ButtonUtil";
import CmmnRestartIcon from "components/mobile/cmmn/CmmnRestartIcon";
import InputBox from "components/mobile/UI/InputBox";
import CmmnRadio from "components/mobile/cmmn/CmmnRadio";

import { useTranslation } from "react-i18next";
import { useBrch } from "components/web/auth/BrchProvider";
import CmmnSysCnfModal from "components/web/cmmn/CmmnSysCnfModal";
import NetStatusImg from "../dsh-brd/component/NetStatusImg";
import CmmnTestPrintIcon from "components/mobile/cmmn/CmmnTestPrintIcon";


// #region 스타일선언
const DashBoardWrap = styled.div`
	display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 20px 0 0 0;
	.dashboard-box {
		background-color: #fff;
		border-radius: 16px;
		width: 100%;
		margin-bottom: 20px;
		box-shadow: 0 0 10px rgba(0,0,0,.1);
	}
    .round-filled-small-btn:hover {
        color: var(--bs-btn-hover-color) !important;
        background-color: var(--bs-btn-hover-bg) !important;
        border-color: var(--bs-btn-hover-border-color) !important;
    }
`;
const MonitoringBox = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px;
    .device-monitoring {
        width: 30%;
        .device-img {
           height: 280px;
        }
    }
    .device-text-info {
        width: 68.5%;
    }
`;
const DeviceMonitoring = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 !important;
    .device-img {
        width: 100% !important;
        height: 150px;
        position: relative;
        // background-image: url(${deviceLogo});
        background-position: center;
        background-size: cover;
        border-radius: 16px;
        padding: 20px;
        border: 1px solid #EEEEEE;
        .device-status {
            display:flex;
            justify-content:space-between;
        }
        .state-box {
            padding: 5px 10px;
            color: #fff;
            font-size: 14px;
            border-radius: 100px;
            width: fit-content;
        }
        .use {
            background-color: #00d45e;
        }
        .wating {
            background-color: #1f93ed;
        }
        .connect-fail {
            background-color: ${({ theme }) => theme.colors.gray8};
        }
    }
`;
const DeviceTextInfo = styled.div`
    width: 68.5%;
    border-bottom: 1px solid #eeeeee;
    .device-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-bottom: 5px;
        border-bottom: 2px solid #EF2929;
        font-size: 16px;
        color: #3b3b3b;
        font-weight: bold;
        margin-bottom: 10px;
        // ${props => props.$brchClsfCd === "KSC" ? "margin-bottom: 10px" : "margin-bottom: 20px"};
        h2 {
            // ${props => props.$brchClsfCd === "KSC" ? "margin-bottom: 0px" : "margin-bottom: 5px"};
            // margin-bottom: 6px;
        }
    }
    .device-sub-title {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
        svg {
            font-size: 14px;
            color: #EF2929;
            margin-right: 10px;
        }
    }
    .info-text-list-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        ul {
            width: 49%;
            li {
                display: flex;
                align-items: center;
                padding: 15px 0;
                height: 50.6px; // 설정버튼 없을 땐 48px;
                border-bottom: 1px solid rgba(0,0,0,.1);
                &:last-child {
                    border-bottom: none;
                }
                h3 {
                    width: 50%;
                    font-size: 16px;
                    color: #3b3b3b;
                    font-weight: 500;
                }
                h5 {
                    width: 50%;
                    font-size: 16px;
                    color: #3b3b3b;
                    font-weight: 400;
                }
            }
        }
    }
    .w-60 {
        width: 60px;
    }
`;
const PointWrap = styled.div`
    width: 50%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h5 {
        width: fit-content !important;
    }
`;

const MtrBoxContentWrap = styled.div`
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .monitoring-box-content {
        width: 49%;
        .dashboard-box {
            margin-top: 20px;
            padding: 20px;
        }
        .device-sub-title {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #3b3b3b;
            font-weight: 500;
            svg {
                font-size: 14px;
                color: #EF2929;
                margin-right: 10px;
            }
        }
    }
`;
const RadioPlusMinusWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;
    border-bottom: 1px solid #eeeeee;
`;
const PlusMinusBtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 50%;
    .circle-icon-btn {
        padding: 10px;
        border-radius: 100px;
        background-color: #fff;
        border: 1.5px solid ${({ theme }) => theme.colors.red};
        transition: all .3s ease-in-out;
        &:hover {
            background-color: ${({ theme }) => theme.colors.red};
        }
        &:hover svg {
            color: #fff;
        }
        svg {
            font-size: 18px;
            color: ${({ theme }) => theme.colors.red};
        }
    }
    .plus-minus-input {
        margin: 0 10px;
        input {
            text-align: center;
            padding: 10px;
        }
        .input_box:last-of-type {
            margin: 0 !important;
        }
    }
`;
const SmallBtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    gap: 10px;
    .btn {
        font-size: 14px;
        padding: 7px 20px;
        // width: 49%;
        width: 100%;
        &:hover {
            color: var(--bs-btn-hover-color) !important;
            background-color: var(--bs-btn-hover-bg) !important;
            border-color: var(--bs-btn-hover-border-color) !important;
        }
    }
`;
// #endregion

const POLLING_INTERVAL = 10000;

export default function DvcMgt() {

    const { t } = useTranslation();
    library.add(faSquare, faPlus, faMinus);
    const { brchId, crdInfo } = useBrch();
    const [pntCalcVal,setPntCalcVal] = useState(0);
    const [defaultPntVal,setDefaultPntVal] = useState(0);
    const brchClsfCd = localStorage.getItem("brchClsfCd");
    const defaultSearchData = {
        brchId: brchId,
        issuPnt: 500, //발급 포인트
        issuQty: 0, //발급 수량
        frcgPtgyClsfCd: "", //무료촬영구분코드
    }
    const pointFreeArr = [
        { label: t("deviceMgtPage.pnt"), value: "PNT" },
        { label: t("deviceMgtPage.free"), value: "QTY" },
    ];
    const controlArr = [
        { label: t("deviceMgtPage.camera"), value: "CAMERA", img: cameraImg },
        { label: t("deviceMgtPage.paymentMachine"), value: "COIND", img: coinImg },
        { label: t("deviceMgtPage.program"), value: "PRGM", img: prgmImg },
        { label: t("deviceMgtPage.program"), value: "OFF", img: offImg },
    ];
    const testPrintArr = [
        { label: t("m_deviceMgtPage.lblVerticalPrint"), value: "V", img: printV },
        { label: t("m_deviceMgtPage.lblHorizontalPrint"), value: "H", img: printH },        
    ];
    const [dvcList, setDvcList] = useState([]);
    const [searchData, setSearchData] = useState(defaultSearchData);
    const [applyingDevices, setApplyingDevices] = useState({});
    const [applyingResetDevices, setApplyingResetDevices] = useState({});

    
    // const [frcgPtgyClsfCd, setFrcgPtgyClsfCd] = useState("");

    // const [modalOpen, setModalOpen] = useState(false);
    // const [modalData, setModalData] = useState(null);

    const [sysModalOpen, setSysModalOpen] = useState(false);
    const [sysModalData, setSysModalData] = useState(null);

    // const openModal = (data, frcg) => {
    //     setModalOpen(true);
    //     setModalData(data);
    //     setFrcgPtgyClsfCd(frcg);
    // }
    const openSysModal = (data) => {
        setSysModalOpen(true);
        setSysModalData(data);
    }
    const getDvcList = useCallback(() => {
        const now = moment();
        callApi("GET", { brchId: brchId }, "/web/api/dvc-mgt/edm/list")
            .then(res => {
                console.log(now.format("HH:mm:ss") + " 장치 재랜더링");
                setDvcList(prevList => {
                    const updatedList = res.map(dvc => {
                        const chngDttm = moment(dvc.chngDttm+'Z');
                        const isConnectionFailed = now.diff(chngDttm, 'seconds') > 30;
                        const isReceivingScreen = now.diff(chngDttm, 'seconds') > 60;

                        // 네트워크 상태 체크
                        if(dvc.netChngDttm){
                            const netChngDttm = moment(dvc.netChngDttm+'Z');
                            const netDiffMillSec = now.diff(netChngDttm,'seconds',true);
                            
                            if( netDiffMillSec <= 120 ){
                                if( dvc.netFailCnt === 0 ){
                                    dvc.netStatCd = "netOn";
                                }else if( dvc.netFailCnt >= 1 && dvc.netFailCnt < 10 ){
                                    dvc.netStatCd = "netWait";
                                }else if ( dvc.netFailCnt >= 10 ) {
                                    dvc.netStatCd = "netWait2";
                                }
                            }else{
                                dvc.netStatCd = "netOff";
                            }
                        }
                        // console.log("eqmtId:", dvc.eqmtId, "isConnectionFail:", isConnectionFailed);

                        const prevDvc = prevList.find(prevDvc => prevDvc.eqmtId === dvc.eqmtId) || {};
                        // applyingDevices === true면 비활성화 false면 활성화
                        const shouldDisableApplying =
                            dvc.prgmStatCd !== "WAITING" ||
                            dvc.slblPnt > 0 ||
                            dvc.slblFrcgPtgyQty > 0 ||
                            isConnectionFailed ||
                            isReceivingScreen;

                        const sholudDisableApplyingReset =
                            dvc.prgmStatCd !== "WAITING" ||
                            isConnectionFailed ||
                            isReceivingScreen;

                        setApplyingDevices(prev => ({ ...prev, [dvc.eqmtId]: shouldDisableApplying}));
                        setApplyingResetDevices(prev => ({ ...prev, [dvc.eqmtId]: sholudDisableApplyingReset}))
                        
                        return {
                            ...dvc,
                            pntSelected: prevDvc.pntSelected || 'PNT',
                            pnt: prevDvc.pnt || defaultPntVal,
                            qty: prevDvc.qty || 2,
                            isConnectionFailed: isConnectionFailed,
                            isReceivingScreen: isReceivingScreen
                        };
                    });
                    // console.log(updatedList);
                    return updatedList;
                });
            })
            .catch(error => {
                console.log(error);
            });
    }, [brchId, defaultPntVal]);
    useEffect(() => {
        // console.log("장치관리 갱신");
        getDvcList();
        const interval = setInterval(getDvcList, POLLING_INTERVAL);
        return () => clearInterval(interval);
    }, [getDvcList]);


    useEffect(() => {
        console.log('useEffect crdInfo: ', crdInfo);
        if(crdInfo){
            setDefaultPntVal(
                crdInfo.natnCd === "JP"?500
                :crdInfo.natnCd === "AU"?10:5000
            );
            setPntCalcVal(
                crdInfo.natnCd === "JP"?100
                :crdInfo.natnCd === "AU"?5:1000
            );
        }        
    },[crdInfo]);

    /*초기 렌더링 후 crdInfo 정보 가져오고 crdInfo체크 후  defaultPntVal가 적용안됨
     *초기 pnt값 설정 작업
     *(화면집입시 안됨)
     */
    /*
    useEffect(() => {
        setDvcList(prevList => {
            return prevList.map((item, index) => {
                console.log(item);
                const updateItem = {
                    ...item,
                    pnt: item.pntSelected === "PNT" ? item.pnt + defaultPntVal : item.pnt,
                    qty: item.pntSelected === "PNT" ? item.qty : Math.min(item.qty + 2, 10)
                }
                setSearchData((prevData) => ({
                    ...prevData,
                    issuPnt: updateItem.pntSelected === "PNT" ? updateItem.pnt : prevData.issuPnt,
                    issuQty: updateItem.pntSelected === "PNT" ? prevData.issuQty : updateItem.qty
                }));
                console.log(item);
                console.log(updateItem);
                return updateItem;
            });
        });
    },[defaultPntVal]);
    */

    const handlePntDataChange = (e, idx) => {
        const { value } = e.target;
        setDvcList(prevList => {
            const newList = [...prevList];
            newList[idx] = {
                ...newList[idx],
                pntSelected: value,
                pnt: value === "PNT" ? defaultPntVal : newList[idx].pnt,
                qty: value === "PNT" ? 2 : newList[idx].qty,
            };
            return newList;
        });
        setSearchData((prevData) => ({
            ...prevData,
            issuPnt: value === "PNT" ? defaultPntVal : 0,
            issuQty: value === "PNT" ? 0 : 2
        }));
    };

    const handleIncrease = (idx) => {
        setDvcList(prevList => {
            return prevList.map((item, index) => {
                if (index !== idx) return item;
                const updateItme = {
                    ...item,
                    pnt: item.pntSelected === "PNT" ? item.pnt + pntCalcVal : item.pnt,
                    qty: item.pntSelected === "PNT" ? item.qty : Math.min(item.qty + 2, 10)
                }
                setSearchData((prevData) => ({
                    ...prevData,
                    issuPnt: updateItme.pntSelected === "PNT" ? updateItme.pnt : prevData.issuPnt,
                    issuQty: updateItme.pntSelected === "PNT" ? prevData.issuQty : updateItme.qty
                }));
                return updateItme;
            });
        });
    };

    const handleDecrease = (idx) => {
        setDvcList(prevList => {
            return prevList.map((item, index) => {
                if (index !== idx) return item;
                const updateItme = {
                    ...item,
                    pnt: item.pntSelected === "PNT" ? Math.max(item.pnt - pntCalcVal, pntCalcVal): item.pnt,
                    qty: item.pntSelected === "PNT" ? item.qty : Math.max(item.qty - 2, 2)
                }
                setSearchData((prevData) => ({
                    ...prevData,
                    issuPnt: updateItme.pntSelected === "PNT" ? updateItme.pnt : prevData.issuPnt,
                    issuQty: updateItme.pntSelected === "PNT" ? prevData.issuQty : updateItme.qty
                }));
                return updateItme;
            })
        })
    };

    const handleCmmnBtnClick = (btnNm, dvc, controlDeviceClsfCd) => {
        const searchParam = { ...searchData, eqmtNo: dvc.eqmtNo, frcgPtgyClsfCd: dvc.pntSelected };
        // const restartParam = { ...restartData, eqmtNo: dvc.eqmtNo, controlDeviceClsfCd: controlDeviceClsfCd };

        // if (applyingDevices[dvc.eqmtId]) {
        //     alert("", "아직 실행중입니다.", () => { return; });
        // }
        // setApplyingDevices(prev => ({ ...prev, [dvc.eqmtId]: true }));

        switch (btnNm) {
            case "cmmnInsertBtn":
                // setApplyingDevices(prev => ({ ...prev, [dvc.eqmtId]: true }));
                if (searchParam.frcgPtgyClsfCd === "PNT") {
                    console.log(searchParam);
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-update")
                        .then(res => {
                            alert("", t("alert.pntInsert"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("alert.pntInsertError"), () => { });
                        })
                } else {
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-update")
                        .then(res => {
                            alert("", t("alert.qtyInsert"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("alert.qtyInsertError"), () => { });
                        })
                }
                break;
            case "cmmnResetBtn":
                if (searchParam.frcgPtgyClsfCd === "PNT") {
                    console.log(searchParam);
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-reset")
                        .then(res => {
                            alert("", t("alert.pntReset"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("alert.pntResetError"), () => { });
                        })
                } else {
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-reset")
                        .then(res => {
                            alert("", t("alert.qtyReset"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("alert.qtyResetError"), () => { });
                        })
                }
            break;
            case "cmmnDeleteBtn":
                if (searchParam.frcgPtgyClsfCd === "PNT") {
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-delete")
                        .then(res => {
                            alert("", t("alert.pntDelete"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("alert.pntDeleteError"), () => { });
                        })
                } else {
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-delete")
                        .then(res => {
                            alert("", t("alert.qtyDelete"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("alert.qtyDeleteError"), () => { });
                        })
                }
                break;
            case "cmmnRestartBtn":
                let eqmt = `${controlDeviceClsfCd}`;
                let eqmtNm;
                let uri = "/web/api/mqtt/send/control-device-restart";
                let params = { eqmtNo: dvc.eqmtNo, controlDeviceClsfCd: controlDeviceClsfCd };
                let confirmText;

                if (eqmt === "PRGM") {
                    eqmtNm = t("deviceMgtPage.restartProgram");
                    confirmText = t("deviceMgtPage.programConfirm");
                } else if (eqmt === "COIND") {
                    eqmtNm = t("deviceMgtPage.restartPaymentDvc");
                    confirmText = t("deviceMgtPage.paymentDvcConfirm");
                } else if (eqmt === "CAMERA") {
                    eqmtNm = t("deviceMgtPage.restartCamera");
                    confirmText = t("deviceMgtPage.cameraConfirm");
                } else if (eqmt === "OFF") {
                    eqmt = "PRGM";
                    uri = "/web/api/mqtt/send/control-device";
                    eqmtNm = t("deviceMgtPage.programOff");
                    params = { eqmtNo: dvc.eqmtNo, controlDeviceClsfCd: "PRGM", cmdCd: "OFF" }
                    confirmText = t("deviceMgtPage.programOffConfirm");
                }
                // modalConfirm으로 변경
                modalConfirm("", confirmText, () => {
                    callApi("GET", params, uri)
                        .then(res => {
                            alert("", `${eqmtNm}`, () => { }, "pr-15", "common.closeLable");
                        })
                        .catch(error => {
                            alert("", `${t("alert.dvcRestartError")}`, () => { }, "pr-15");
                        })
                }, "pr-15")
                break;
            case "cmmnTestPrintBtn":
                
                const testPrintUrl = "/web/api/mqtt/send/test-print";
                const testPrintParams = { eqmtNo: dvc.eqmtNo, cmdCd: controlDeviceClsfCd };
                
                modalConfirm("", t("m_deviceMgtPage.testPrintConfirm"), () => {
                    callApi("GET", testPrintParams, testPrintUrl)
                        .then(res => {
                            alert("", t("m_alert.testPrintSuccess"), () => { }, "", "common.closeLable");
                        })
                        .catch(error => {
                            alert("", `${t("m_alert.dvcTestPrintError")}`, () => { });
                        })
                })
                break;            
            default: break;
        }
    };

    // useEffect(() => {
    //     console.log(applyingDevices);
    // }, [applyingDevices])

    return (
        <div className="padding-box">
            <div className="title-wrap">
                <div className="title">
                    <div className="alignset">
                        <img src={titleLogo} alt={t("deviceMgtPage.dvcMgt")} />
                        <h2>{t("deviceMgtPage.dvcMgt")}</h2>
                    </div>
                    <p>Home {">"} {t("deviceMgtPage.dvcMgt")}</p>
                </div>
            </div>
            <DashBoardWrap>
                {dvcList.map((dvc, idx) => (
                    <div className="dashboard-box" key={idx}>
                        <MonitoringBox>
                            <DeviceMonitoring className="device-monitoring">
                                {!dvc.isConnectionFailed ?
                                    <div className="device-img" style={{ backgroundImage: `url(${dvc.prgmCptrImgCn})` }}>
                                        <div className="device-status">
                                            <div className={`state-box ${dvc.prgmStatCd === "INUSE" ? "use" : "wating"}`}>
                                                {dvc.prgmStatCd === "INUSE" ? t("deviceMgtPage.inuse") : t("deviceMgtPage.waiting")}
                                            </div>
                                            <NetStatusImg netStatCd={dvc.netStatCd} />
                                        </div>
                                    </div>
                                    :
                                    !dvc.isReceivingScreen ?
                                    <div className="device-img" style={{ backgroundImage: `url(${receiveScreen})` }}>
                                        <div className="device-status">
                                            <div className={`state-box ${dvc.prgmStatCd === "INUSE" ? "use" : "wating"}`}>
                                                {dvc.prgmStatCd === "INUSE" ? t("deviceMgtPage.inuse") : t("deviceMgtPage.waiting")}
                                            </div>
                                            <NetStatusImg netStatCd={dvc.netStatCd} />
                                        </div>
                                    </div>
                                    :
                                    <div className="device-img" style={{ backgroundImage: `url(${connectFailImg})` }}>
                                        <div className="device-status">
                                            <div className={"state-box connect-fail"} >
                                                {dvc.isConnectionFailed && t("deviceMgtPage.connectFailed")}
                                            </div>
                                            <NetStatusImg netStatCd={dvc.netStatCd} />
                                        </div>
                                    </div>
                                }
                            </DeviceMonitoring>
                            <DeviceTextInfo className="device-text-info" $brchClsfCd={brchClsfCd}>
                                <div className="device-title">
                                    <h2>{dvc.eqmtNm}</h2>
                                    <ButtonUtil className="btn btn-danger round-filled-small-btn small-btn w-60"
                                        value={t("deviceMgtPage.config")}
                                        onClick={() => { openSysModal(dvc) }}
                                    />
                                </div>
                                <div>
                                    <h3 className="device-sub-title">
                                        <FontAwesomeIcon icon={faSquare} />
                                        {t("deviceMgtPage.dvcInfo")}
                                    </h3>
                                    <div className="info-text-list-wrap">
                                        <ul>
                                            <li>
                                                <h3>{t("deviceMgtPage.prgmStat")}</h3>
                                                {!dvc.isConnectionFailed ?
                                                    <h5>{dvc.prgmStatCd === "INUSE" ? t("deviceMgtPage.inuse") : t("deviceMgtPage.waiting")}</h5>
                                                    :
                                                    <h5>{dvc.isConnectionFailed && t("deviceMgtPage.connectFailed")}</h5>
                                                }
                                            </li>
                                            <li>
                                                <h3>{t("deviceMgtPage.prntStat")}</h3>
                                                <h5>{(dvc.prntStatMsgCn === null || dvc.prntStatMsgCn === undefined) ? "-" : dvc.prntStatMsgCn}</h5>
                                            </li>
                                            <li>
                                                <h3>{t("deviceMgtPage.remPapr")}</h3>
                                                <h5>{(dvc.remPaprQty === null || dvc.remPaprQty === undefined) ? '0' : dvc.remPaprQty.toLocaleString()}{t("deviceMgtPage.sheet")}</h5>
                                            </li>
                                            <li>
                                                <h3>{t("deviceMgtPage.pntAndFrcgPtgy")}</h3>
                                                <h5>
                                                    {(dvc.slblPnt === null || dvc.slblPnt === undefined) ? '0' : dvc.slblPnt.toLocaleString()}
                                                    P/
                                                    {(dvc.slblFrcgPtgyQty === null || dvc.slblFrcgPtgyQty === undefined) ? '0' : dvc.slblFrcgPtgyQty.toLocaleString()}{t("deviceMgtPage.page")}
                                                </h5>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <h3>{t("deviceMgtPage.slblPnt")}</h3>
                                                <PointWrap>
                                                    <h5>{(dvc.slblPnt === null || dvc.slblPnt === undefined) ? '0' : dvc.slblPnt.toLocaleString()}P</h5>
                                                    {/*<PointInfoBox>
                                                        <ButtonUtil className="btn round-solid-small-btn btn-outline-secondary"
                                                            value={t("deviceMgtPage.issuHistory")}
                                                            onClick={() => { openModal(dvc, "PNT"); setModalTitle("포인트 발급 내역"); }}
                                                        />
                                                        <ButtonUtil className="btn round-solid-small-btn btn-outline-secondary"
                                                            value={t("deviceMgtPage.useHistory")}
                                                            onClick={() => { openModal(dvc); setModalTitle("포인트 사용 내역"); }}
                                                        />
                                                    </PointInfoBox>*/}
                                                </PointWrap>
                                            </li>
                                            <li>
                                                <h3>{t("deviceMgtPage.slblFrcgPtgy")}</h3>
                                                <PointWrap>
                                                    <h5>{(dvc.slblFrcgPtgyQty === null || dvc.slblFrcgPtgyQty === undefined) ? '0' : dvc.slblFrcgPtgyQty.toLocaleString()}{t("deviceMgtPage.page")}</h5>
                                                    {/*<PointInfoBox>
                                                        <ButtonUtil className="btn round-solid-small-btn btn-outline-secondary"
                                                            value={t("deviceMgtPage.issuHistory")}
                                                            onClick={() => { openModal(dvc, "QTY"); setModalTitle("무료 발급 내역"); }}
                                                        />
                                                        <ButtonUtil className="btn round-solid-small-btn btn-outline-secondary"
                                                            value={t("deviceMgtPage.useHistory")}
                                                            onClick={() => { openModal(dvc); setModalTitle("무료 사용 내역"); }}
                                                        />
                                                    </PointInfoBox>*/}
                                                </PointWrap>
                                            </li>
                                            <li>
                                                <h3>{t("deviceMgtPage.rcUseAmt")}</h3>
                                                <h5>{crdInfo && crdInfo.natnCd === "KR" ? "₩" : crdInfo && crdInfo.natnCd === "JP" ? "¥" : "$"} {(dvc.rcUseAmt === null || dvc.rcUseAmt === undefined) ? 0 : dvc.rcUseAmt}</h5>
                                            </li>
                                            <li>
                                                <h3>{t("deviceMgtPage.rcUseDttm")}</h3>
                                                <h5>{(dvc.convRcUseDttm === null || dvc.convRcUseDttm === undefined) ? "-" : dvc.convRcUseDttm}</h5>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </DeviceTextInfo>
                        </MonitoringBox>
                        <MtrBoxContentWrap>
                            <div className="monitoring-box-content">
                                <h3 className="device-sub-title">
                                    <FontAwesomeIcon icon={faSquare} />
                                    {t("deviceMgtPage.control")}
                                </h3>
                                <div className="dashboard-box">
                                    <CmmnRestartIcon
                                        dataArray={controlArr}
                                        handleClick={(controlDeviceClsfCd) => handleCmmnBtnClick("cmmnRestartBtn", dvc, controlDeviceClsfCd)}
                                    />
                                    <CmmnTestPrintIcon
                                        dataArray={testPrintArr}
                                        handleClick={(controlDeviceClsfCd) => handleCmmnBtnClick("cmmnTestPrintBtn", dvc, controlDeviceClsfCd)}
                                    />
                                </div>
                            </div>
                            <div className="monitoring-box-content">
                                <h3 className="device-sub-title">
                                    <FontAwesomeIcon icon={faSquare} />
                                    {t("deviceMgtPage.pntAndFrcg")}
                                </h3>
                                <div className="dashboard-box">
                                    <RadioPlusMinusWrap>
                                        <CmmnRadio
                                            id={`frcgPtgyClsfCd${idx}`}
                                            dataArray={pointFreeArr}
                                            defaultVal={dvc.pntSelected}
                                            tagName={`frcgPtgyClsfCd${idx}`}
                                            onSelectChange={(e) => { handlePntDataChange(e, idx) }}
                                        />
                                        <PlusMinusBtnWrap>
                                            <ButtonUtil className="circle-icon-btn"
                                                onClick={() => { handleDecrease(idx) }}
                                            >
                                                <FontAwesomeIcon icon={faMinus} />
                                            </ButtonUtil>
                                            <div className="plus-minus-input">
                                                <InputBox
                                                    type="text"
                                                    id={`input${idx}`}
                                                    name={`input${idx}`}
                                                    className="input_box"
                                                    value={dvc.pntSelected === "PNT" ? `${dvc.pnt}P` : `${dvc.qty}${t("deviceMgtPage.page")}`}
                                                    disabled={true}
                                                />
                                            </div>
                                            <ButtonUtil className="circle-icon-btn"
                                                onClick={() => { handleIncrease(idx) }}
                                            >
                                                <FontAwesomeIcon icon={faPlus} />
                                            </ButtonUtil>
                                        </PlusMinusBtnWrap>
                                    </RadioPlusMinusWrap>
                                    <SmallBtnWrap>
                                        <ButtonUtil
                                            className="btn btn-danger round-filled-btn"
                                            value={t("deviceMgtPage.apply")}
                                            onClick={() => { handleCmmnBtnClick("cmmnInsertBtn", dvc) }}
                                            disabled={applyingDevices[dvc.eqmtId]}
                                        />
                                        <ButtonUtil
                                            className="btn btn-light round-filled-gray-btn bottom-modal-clos-btn"
                                            value={t("deviceMgtPage.reset")}
                                            onClick={() => { handleCmmnBtnClick("cmmnResetBtn", dvc) }}
                                            disabled={applyingResetDevices[dvc.eqmtId]}
                                        />
                                        {/* <ButtonUtil
                                            className="btn btn-light round-filled-gray-btn bottom-modal-close-btn"
                                            value={t("deviceMgtPage.clear")}
                                            onClick={() => { handleCmmnBtnClick("cmmnDeleteBtn", dvc) }}
                                        /> */}
                                    </SmallBtnWrap>
                                </div>
                            </div>
                        </MtrBoxContentWrap>
                    </div>
                ))}
                {/* <CmmnCrdHistModal
                    show={modalOpen}
                    data={modalData}
                    onHide={() => setModalOpen(false)}
                    title={modalTitle}
                    frcgPtgyClsfCd={frcgPtgyClsfCd}
                /> */}
                <CmmnSysCnfModal
                    show={sysModalOpen}
                    data={sysModalData}
                    onHide={() => setSysModalOpen(false)}
                    brchClsfCd={brchClsfCd}
                    t={t}
                />
            </DashBoardWrap >
        </div >
    )
}